export const GET_LIST_DANHSACHCUAHANG = "GET_LIST_DANHSACHCUAHANG";
export const GET_LIST_DANHSACHCUAHANG_SUCCESS =
  "GET_LIST_DANHSACHCUAHANG_SUCCESS";
export const GET_LIST_DANHSACHCUAHANG_FAILURE =
  "GET_LIST_DANHSACHCUAHANG_FAILURE";

//Start
export const UPDATE_SEARCHDATA_CUAHANG = "UPDATE_SEARCHDATA_CUAHANG";
export const UPDATE_THONGTIN_CUAHANG = "UPDATE_THONGTIN_CUAHANG";
